import { event as gTagEvent } from 'vue-gtag'
import { getFlags } from './feature-flags'
import Cookies from 'js-cookie'
import { useLandingPage } from '@/stores/landingPage'
import CONSTANTS from '@/helpers/constants'

let trigger = null

export const loadStanAnalytics = (url) => {
	const script = document.createElement('script')
	script.src = url
	script.async = true
	document.head.appendChild(script)
	script.onload = () => {
		console.log('stan-analytics loaded')
		trigger = window.stanAnalytics
	}
	script.onerror = (e) => {
		console.log('stan-analytics failed to load',e)
	}	
}


export const stanAnalytics = async (name, opts = {}) => {
	const meta = opts.meta || {}
	const props = opts.props || {}
	const referrer = opts.referrer

	props.experiments = getFlags()
	const landingPage = useLandingPage()

	if (landingPage.forceExperiment) {
		delete props.experiments['landing-page-v6-vs-v8']
	}

	if (trigger) {
		const analyticsReturn = trigger(name, {
			meta,
			props,
			referrer,
		})
		if (Cookies.get('targeting_cookies') == 'true') {
			const flattenOptions = { ...analyticsReturn }
			Object.keys(flattenOptions).forEach(v => {
				if (v.includes('-')) {
					flattenOptions[v.replace('-', '_')] = flattenOptions[v]
					delete flattenOptions[v]
				}
			})

			// google tracking
			const googleTagEventName = CONSTANTS.ANALYTICS_MAPPING[name] ?? name
			flattenOptions.send_to = CONSTANTS.GOOGLE_AD_CONVERSION_ID
			gTagEvent(googleTagEventName, flattenOptions)
		}
	}
}
